/**
 * 大屏状态管理
 */
import {noticeScrollCount, noticeScrollPeriod, themeColor} from "@/views/big-screen/theme-setting";
import {getStore, setStore} from "@/util/store";
import {validatenull} from "@/util/validate";


const bigScreen = {
    state: {
        loading: false,
        //状态栏颜色（装饰动画）
        statusBarColor: themeColor.main_light,
        //标题颜色
        headerTextColor: themeColor.header_title_normal_color,
        //标题缩放
        headerTextScaled: false,
        //即时消息的播放控制
        tipLoading: false,
        //心跳检测，单位ms
        heartCheckTime: 0,
        //通知是否显示的总开关，控制间隔。true为打开，false为关闭
        showNoticeSwitch: true,
        //通知滚动次数
        noticeScrollCount: 0,
        //总开关的定时器
        refreshSwitchTime: null,
        //总开关的定时器的时间，单位秒
        refreshSwitchTimeSec: 0,
        //是否显示通知
        showNotice: false,
        //通知的实体
        noticeObj: getStore({name: 'noticeObj'}) || {},
        refreshTime: null,
        //设备的设置
        setting: getStore({name: 'setting'}) || {}
    },
    actions: {
        setLoadingOk({commit, dispatch}) {
            commit('SET_LOADING', false);
            commit('SET_STATUSBAR_COLOR', themeColor.loading_color_ok);
        },
        setLoadingErr({commit, dispatch}) {
            commit('SET_STATUSBAR_COLOR', themeColor.loading_color_err);
        },
        setHeaderTextColorErr({commit, dispatch}) {
            commit('SET_HEADER_TEXT_COLOR', themeColor.loading_color_err);
        },
        setHeaderTextColorHeartCheck({commit, dispatch}) {
            commit('SET_HEADER_TEXT_COLOR', themeColor.header_title_heart_check_color);
            setTimeout(() => {
                commit('SET_HEADER_TEXT_COLOR', themeColor.header_title_normal_color);
            }, 1000)
        },
        setHeaderTextColorPushed({commit, dispatch}) {
            commit('SET_HEADER_TEXT_COLOR', themeColor.header_title_heart_pushed_color);
            setTimeout(() => {
                commit('SET_HEADER_TEXT_COLOR', themeColor.header_title_normal_color);
            }, 1000)
        },
        setHeaderTextScaled({commit, dispatch}) {
            commit('SET_HEADER_TEXT_SCALED', true);
            setTimeout(() => {
                commit('SET_HEADER_TEXT_SCALED', false);
            }, 700)
        },
        setTipLoading({commit, dispatch}, flag = false) {
            commit('SET_TIP_LOADING', flag);
        },

        setShowNoticeSwitch({commit, dispatch}, flag = false) {
            commit('SET_SHOW_NOTICE', flag);
        },
        setShowNotice({commit, dispatch}, flag = false) {
            commit('SET_SHOW_NOTICE', flag);
        },
        setNoticeObj({commit, dispatch}, noticeObj = {}) {
            commit('SET_NOTICE_OBJ', noticeObj);

            const {beginTimeLong = 0, endTimeLong = 0} = noticeObj
            if (bigScreen.state.refreshTime) {
                clearInterval(bigScreen.state.refreshTime)
            }
            if (validatenull(noticeObj)) {
                return
            }
            // console.info("通知显示计时器将开启")
            bigScreen.state.refreshTime = setInterval(() => {
                const showNoticeSwitch = bigScreen.state.showNoticeSwitch
                const timeMill = new Date().getTime()
                const isValid = timeMill >= beginTimeLong && timeMill < endTimeLong;
                const showNotice = showNoticeSwitch ? isValid : false
                // console.info("Notice Valid", isValid)
                // console.info("Notice Switch", showNoticeSwitch)

                if (bigScreen.state.showNotice !== showNotice) {
                    commit('SET_SHOW_NOTICE', showNotice);
                    commit('SET_NOTICE_SCROLL_COUNT', 0);

                    // console.info("Notice显示", showNotice)

                    if (!showNotice) {
                        if (bigScreen.state.refreshTime) {
                            clearInterval(bigScreen.state.refreshTime)
                            console.info("通知显示计时器关闭")
                        }
                        if (bigScreen.state.refreshSwitchTime) {
                            clearInterval(bigScreen.state.refreshSwitchTime)
                        }
                        // console.info("间隔计时器将开启")
                        bigScreen.state.refreshSwitchTime = setInterval(() => {
                            bigScreen.state.refreshSwitchTimeSec++
                            console.info("间隔计时器", bigScreen.state.refreshSwitchTimeSec)
                            if (bigScreen.state.refreshSwitchTimeSec >= noticeScrollPeriod) {
                                commit('SET_SHOW_NOTICE_SWITCH', true);
                                commit('SET_REFRESH_SWITCH_TIME_SEC', 0);
                                if (bigScreen.state.refreshSwitchTime) {
                                    clearInterval(bigScreen.state.refreshSwitchTime)
                                    // console.info("间隔计时器关闭")
                                }

                                dispatch("setNoticeObj", getStore({name: 'noticeObj'}) || {})
                            }
                        }, 1000)
                    }
                }
            }, 1000)
        },
        setNoticeScrollCount({commit, dispatch}, count = 0) {
            commit('SET_TIP_LOADING', count);
        },
        //维护通知轮播次数累加
        setAddNoticeScrollCount({commit, dispatch}) {
            bigScreen.state.noticeScrollCount++;
            if (bigScreen.state.noticeScrollCount >= noticeScrollCount) {
                commit('SET_SHOW_NOTICE_SWITCH', false)
                commit('SET_NOTICE_SCROLL_COUNT', 0)
            }
        },

        //维护通知轮播次数累加
        setSetting({commit, dispatch},settingMap={}) {
            commit('SET_SETTING', settingMap);
        },
    },
    mutations: {
        SET_LOADING: (state, loading = false) => {
            state.loading = loading;
        },
        SET_STATUSBAR_COLOR: (state, color = '') => {
            state.statusBarColor = color
        },
        SET_HEADER_TEXT_COLOR: (state, color = '') => {
            state.headerTextColor = color
        },
        SET_HEADER_TEXT_SCALED: (state, flag = false) => {
            state.headerTextScaled = flag
        },
        SET_TIP_LOADING: (state, flag = false) => {
            state.tipLoading = flag
        },
        SET_SHOW_NOTICE_SWITCH: (state, flag = false) => {
            state.showNoticeSwitch = flag
        },
        SET_SHOW_NOTICE: (state, flag = false) => {
            state.showNotice = flag
        },
        SET_NOTICE_OBJ: (state, noticeObj = {}) => {
            state.noticeObj = noticeObj
            setStore({name: 'noticeObj', content: state.noticeObj})
        },
        SET_NOTICE_SCROLL_COUNT: (state, count = 0) => {
            state.noticeScrollCount = count
        },

        SET_REFRESH_SWITCH_TIME_SEC: (state, count = 0) => {
            state.refreshSwitchTimeSec = count
        },
        SET_SETTING: (state, settingMap = {}) => {
            state.setting = settingMap;
            setStore({name: 'setting', content:  state.setting})
        },

    }
}
export default bigScreen
